import React, { ReactNode, useMemo, useState } from "react";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import { Dropdown, DropdownProps } from "antd";

import XtInputSearch from "@/components/Xt/Input/Search";
import XtScrollWindow from "@/components/Xt/scroll/window";

import styles from "./index.module.scss";

const { useTranslation } = Hooks;

type KeyType = string | number;

export interface AppDropdownItemProps extends ObjAny {
  key: KeyType;
  label?: ReactNode;
  keyword?: string;
}

export interface AppDropdownProps extends DropdownProps {
  value?: KeyType;
  onChange?: (arg) => void;
  triggerLabel?: ReactNode;
  items?: AppDropdownItemProps[];
  itemHeight?: number;
  maxHeight?: number;
  placeholder?: string;
}

const WindowUl: React.FC<any> = ({ startIndex, record, value, onChange, height, hide }) => {
  return record.map((item: AppDropdownItemProps, index) => {
    return (
      <button
        key={item.key}
        className={cx("btnTxt ant-dropdown-menu-item", styles.li, { "ant-dropdown-menu-item-selected": value === item.key })}
        style={{ height, top: (startIndex + index) * height + "px" }}
        onClick={(e) => {
          e.stopPropagation();
          onChange && onChange(item.key);
          hide && hide();
        }}
      >
        {item.label}
      </button>
    );
  });
};

const Main: React.FC<AppDropdownProps> = ({
  value,
  onChange,
  triggerLabel,
  items = [],
  itemHeight = 32,
  maxHeight = 200,
  placeholder,
  ...rest
}) => {
  const t = useTranslation();
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const itemsFormat = useMemo(() => {
    if (!keyword) return items;
    const str = keyword.replace(/\//g, "_").replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
    const ary: AppDropdownItemProps[] = [];
    items.map((item) => {
      if (!item.key) return ary.push(item);
      if (
        new RegExp(str, "i").test(item.key + "") ||
        (item.keyword && new RegExp(str, "i").test(item.keyword)) ||
        (typeof item.label === "string" && new RegExp(str, "i").test(item.label))
      ) {
        ary.push(item);
      }
    });
    return ary;
  }, [keyword, items]);

  const atvItem = useMemo(() => {
    if (value === undefined || !items.length) return;
    return items.find((obj) => obj.key === value);
  }, [value, items]);

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      overlayClassName={styles.main}
      dropdownRender={() => {
        return (
          <div className={styles.dropdownRender}>
            <div className={styles.search}>
              <XtInputSearch value={keyword} onInput={setKeyword} placeholder={placeholder || t("trade.search")} />
            </div>
            <XtScrollWindow
              className={styles.XtScrollWindow}
              style={{ maxHeight }}
              height={itemHeight}
              dataAry={itemsFormat}
              defaultWinHeight={maxHeight}
              isDisableObserver={true}
            >
              <WindowUl value={value} onChange={onChange} height={itemHeight} hide={() => setOpen(false)} />
            </XtScrollWindow>
          </div>
        );
      }}
      {...rest}
    >
      <button className={cx("btnTxt btnDrop", styles.trigger)} onClick={(e) => e.preventDefault()}>
        {triggerLabel || (atvItem && atvItem.label)}
      </button>
    </Dropdown>
  );
};

export default Main;
